import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Lake Charles, LA?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a Lake Charles post office can take 2–6 months. For petrochemical engineers with plant assignments, casino industry professionals with conference travel, and Southwest Louisiana families booking Gulf Coast cruises, that timeline is simply not viable.",
  },
  {
    q: "Can petrochemical and LNG engineers in Lake Charles get a passport quickly for international assignments?",
    a: "Absolutely — industrial engineers are one of our most common client types in Lake Charles. Plant turnaround assignments to Saudi Arabia, the Netherlands, South Korea, and the UK often arrive with 10–14 days notice. We regularly process expedited renewals for Calcasieu corridor industrial professionals who need their passports before a plant assignment or technology transfer visit. Contact us the moment your assignment is confirmed.",
  },
  {
    q: "Can Lake Charles casino employees get expedited passports for industry travel?",
    a: "Yes. Gaming executives, hospitality managers, and technology vendors from Lake Charles casino resorts regularly travel to Macau, Singapore, Las Vegas, and London for industry conferences. Many have not traveled internationally since before the pandemic and hold expired passports. We process expedited renewals with the timeline flexibility these industry trips require.",
  },
  {
    q: "How quickly can Lake Charles families get passports for a Galveston or New Orleans cruise?",
    a: "Lake Charles residents have convenient access to both Port of Galveston (100 miles west) and Port of New Orleans (200 miles east). If your sailing is within 2–6 weeks, standard processing cannot meet your deadline. Fast Passport Center can process an expedited renewal or new passport in as little as 2–9 business days. Start your order as soon as you discover the issue.",
  },
  {
    q: "Does Fast Passport Center have an office in Lake Charles?",
    a: "No — we operate remotely, which is why we can serve all of Southwest Louisiana without you driving to Houston. Start your order online, follow the checklist we provide, and ship your documents overnight from any UPS or FedEx location in Lake Charles, Sulphur, or Westlake. We handle the rest.",
  },
  {
    q: "What is the nearest regional passport agency to Lake Charles, LA?",
    a: "The nearest regional passport agency is the Houston Passport Agency at Mickey Leland Federal Building, 1919 Smith St, Ste 1400, Houston, TX 77002 — approximately 100 miles from Lake Charles. Regional agencies are for documented urgent travel emergencies only, require appointments that are often unavailable, and require an in-person visit. Fast Passport Center eliminates the drive and the uncertainty.",
  },
  {
    q: "What documents do I need for an expedited passport from Lake Charles?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function LakeCharlesFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Lake Charles and Southwest Louisiana travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a href="tel:8772530084" className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap">
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}